import Grid, { GridProps } from '@material-ui/core/Grid'
import React from 'react'

/** Wrapper component for &lt;Grid container /> */
const GridContainer = React.forwardRef<unknown, GridProps>((props, ref) => (
    <Grid container innerRef={ref} {...props} />
))

GridContainer.displayName = 'GridContainer'

export default GridContainer
